<template>
  <div class="teacherManger">
    <!-- 校园树 -->
    <!-- <el-aside width="240px" style="padding-right:10px;overflow: auto;background: #fff;border-radius: 4px;">
        <div class='sidebar'>
          <div class='title'>校区</div>
          <tree @setIds="setIdEvent"></tree>
        </div>
    </el-aside>-->
    <!-- 表格主体 -->
    <el-card v-auth="'maturestudent_/classInfoStudent/register'">
      <el-row :gutter="20" style="margin-bottom: 10px">
        <el-col :sm="12" :md="6" :lg="6">
          <el-cascader
            @change="campusIdChange"
            style="width: 100%"
            clearable
            v-model="searchForm.campusIds"
            :show-all-levels="false"
            :collapse-tags="true"
            :props="CampusProps"
            placeholder="请选择所属校区"
            :options="campusList"
          ></el-cascader>
        </el-col>
        <el-col :sm="12" :md="6" :lg="6">
          <el-cascader
            style="width: 100%"
            clearable
            v-model="searchForm.subjectCourseId"
            :show-all-levels="false"
            :props="subjectTreeProps"
            placeholder="请输入所属科目"
            :options="subjectTreeList"
            @change="subjectChange"
          ></el-cascader>
        </el-col>
        <el-col :sm="12" :md="6" :lg="6">
          <el-select
            style="width: 100%"
            v-model="searchForm.id"
            clearable
            placeholder="请选择班级"
          >
            <el-option
              v-for="item in classOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :sm="12" :md="6" :lg="6">
          <el-input
            type="text"
            v-model="searchForm.name"
            placeholder="班级名称"
          ></el-input>
        </el-col>

        <!-- <el-col :sm="12" :md="5" :lg="5" style="float:right">
          <el-button 
            type="primary"
            style="float:right"
            @click="showAddDialog = true;getSubjectTreeList()"
            icon="el-icon-plus"
          >添加教师</el-button>
        </el-col> -->
      </el-row>
      <el-row>
        <el-col :sm="12" :md="6" :lg="6" style="display: flex">
          <el-date-picker
            style="width: 100%"
            v-model="createTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="timeRangeChangw"
          ></el-date-picker>
          <el-button
            type="primary"
            @click="(currentPage = 1), getPageList()"
            icon="el-icon-search"
            >查询</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <el-card class="box-card" v-auth="'maturestudent_/classInfoStudent/register'">
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        class="teacherTable"
        :data="tableData"
        border
        style="width: 100%; margin-top: 20px"
        prop="date"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="排序"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="areaName"
          show-overflow-tooltip
          label="地区"
        ></el-table-column>
        <el-table-column prop="campusName" label="校区" width="100"></el-table-column>
        <el-table-column
          prop="subjectName"
          label="科目"
          width="100"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column prop="courseName" label="课程" width="150"></el-table-column>
        <el-table-column
          prop="headTeacherName"
          label="班主任"
          width="150"
        ></el-table-column>
        <el-table-column prop="teacherName" label="教师" width="150"></el-table-column>
        <el-table-column
          label="班级"
          width="300"
          prop="name"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="课程数"
          prop="idCount"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column label="出勤率" sortable prop="statistics"></el-table-column>
        <el-table-column label="完成率" sortable prop="homeStatistics"></el-table-column>
      </el-table>
      <div class="table_bottom">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          style="margin-top: 20px; text-align: left"
          background
          layout="prev, pager, next, jumper,  total, sizes"
          :total="total"
          :page-size.sync="pageSize"
          :current-page.sync="currentPage"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      ClassInfoTreeList: [],
      classOptions: [],
      CampusProps: {
        value: "id",
        children: "children",
        label: "name",
        multiple: true,
      },
      fileAction: `${process.env.BASE_URL}/system/uploadFile`,
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      subjectTreeList: [],
      treeData: [], //校区树
      propsxxx: {
        children: "children",
        label: "name",
      },
      tableData: [], //表格数据
      campusList: [],
      searchForm: {
        campusIds: "",
        subjectCourseId: "",
        id: "",
        name: "",
        startTime: "",
        endTime: "",
      },
      createTime: "",
      showAddDialog: false,
      showEditorDialog: false,
      addwidth: "60%",
      loading: false,
      campusId: "",
      searchCampusId: null,
      form: {
        campusId: null,
        account: "",
        name: "",
        headPic: "",
        enabled: 1,
        remark: "",
        detail: "",
      },
      editForm: [],
      id: "",
      pageSize: 10,
      currentPage: 1,
      total: 0, //总的数据数
      start: "",
      end: "",
      pageNumber: [
        {
          value: 10,
          label: 10,
        },
        {
          value: 20,
          label: 20,
        },
      ],
    };
  },
  components: {},
  computed: {},
  methods: {
    campusIdChange(val) {
      console.log(val);
    },
    timeRangeChangw(val) {
      console.log(val);
      if (val) {
        this.searchForm.startTime = val[0];
        this.searchForm.endTime = val[1];
      }
    },
    subjectChange(val) {
      this.searchForm.courseId = val[2] ? val[2] : "";
      console.log(val);
      this.getClassInfoList();
    },
    getClassInfoList() {
      this.api.signInLog
        .getClassInfoList({ subjectCourseId: this.searchForm.courseId })
        .then((result) => {
          this.classOptions = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getSubjectTreeList() {
      // 获取课程
      this.api
        .getSubjectCourseTreeList()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCampusList() {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    indexMethod(index) {
      return index + 1 + (this.currentPage - 1) * 10;
    },
    handleRemove(file, fileList) {
      // this.uploadList = fileList;
      // if (this.picUrl.length > 0) {
      //   for (let i = 0; i < this.picUrl.length; i++) {
      //     if (this.picUrl[i].uid == file.uid) {
      //       this.picUrl.splice(i, 1);
      //     }
      //   }
      // }
    },
    handleChange(file, fileList) {
      // this.picUrl = fileList.slice(-1);
    },
    beforeUpload(file) {
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    UploadSuccess(res, file, fileList, val) {
      if (this.showEditorDialog) {
        this.form.headPic = res.data;
        console.log("22222", this.form.headPic);
      } else if (this.showAddDialog) {
        this.form.headPic = res.data;
        console.log("233333333", this.form.headPic);
      }
      // this.picUrl.push({
      //   name: res.data[0].FileName,
      //   url: res.data[0].FilePath
      // });
    },
    sizeChange() {
      this.pageChange();
    },
    currentChange() {
      this.pageChange();
    },
    pageChange() {
      // //分页发生变化时
      // let data;
      // if (this.inp && !this.campusId) {
      //   data = {
      //     pageNumber: this.currentPage,
      //     pageSize: this.pageSize,
      //   };
      // } else {
      //   data = {
      //     pageNumber: this.currentPage,
      //     pageSize: this.pageSize,
      //   };
      // }
      // this.api.agentUserInfo.teacherPageList(data).then(result => {
      //   if (result.success) {
      //     this.loading = false;
      //     this.tableData = result.data.records;
      //   }
      // });
      this.getPageList();
    },
    paginationInit() {
      if (this.currentPage == 1 && this.total <= this.pageSize) {
        this.start = 1;
        this.end = this.total;
      } else if (this.currentPage * this.pageSize < this.total) {
        this.start = (this.currentPage - 1) * this.pageSize + 1;
        this.end = this.currentPage * this.pageSize;
      } else if (this.currentPage * this.pageSize >= this.total) {
        this.start = (this.currentPage - 1) * this.pageSize + 1;
        this.end = this.total;
      }
      console.log(this.start, this.end);
    },
    getPageList() {
      //获取表格数据
      var sf = this.searchForm;
      if (!sf.startTime) {
        this.$message.warning("请选择时间");
        return false;
      }
      var newAr = [];
      sf.campusIds.forEach((e) => {
        newAr.push(e[2]);
      });
      let data = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        campusIds: newAr,
        subjectCourseId: sf.subjectCourseId ? sf.subjectCourseId[2] : "",
        id: sf.id,
        name: sf.name,
        startTime: sf.startTime,
        endTime: sf.endTime,
      };
      this.loading = true;
      // console.log(data)
      this.api.agentUserInfo.getMatureStudentList(data).then((result) => {
        if (result.success) {
          this.tableData = result.data.records;
          for (let item of this.tableData) {
            item.enabled = String(item.enabled);
          }
          this.total = Number(result.data.total);
          this.paginationInit();
          this.loading = false;
        }
      });
    },

    // 重置
    resetaddForm() {
      this.$refs.addForm.resetFields();
    },

    clearForm() {
      this.form = {
        campusId: null,
        account: "",
        name: "",
        headPic: "",
        enabled: 1,
        remark: "",
        detail: "",
      };
    },
  },
  created() {
    // this.getTreeData();
    this.getSubjectTreeList(() => {
      this.getClassInfoList();
    });
    this.getCampusList();
  },
};
</script>

<style scoped>
.teacherManger {
}

.teacherManger .el-radio {
  margin-right: 10px;
}
.el-input--suffix .el-input__inner {
  padding-right: 20px;
}

.sidebar,
.sidebarRight {
  background: white;
  padding: 0 20px 20px 0;
}

.sidebar .title,
.sidebarRight .title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  border-bottom: 1px solid #e5ecf0;
}

.sidebarRight .search {
  background: #66b1ff !important;
  border: 0;
  outline: none;
  border-radius: 0;
  height: 40px;
  color: white !important;
}

.teacherManger .caret-wrapper {
  position: absolute;
  right: 0;
  top: -5px;
}

.addDialog .el-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
}

.addDialog .dialogLeft {
  text-align: right;
  padding-right: 10px;
}

.addDialog .el-dialog__body {
  padding: 15px 20px !important;
}

.table_bottom {
  margin: 20px 0;
}
.upload-img {
  width: 80px;
  height: 80px;
}
.plan-icon {
  font-size: 16px;
  color: #4d94ff;
  margin-right: 10px;
}
</style>
<style lang="less" scoped>
.list-name-img {
  display: flex;
  flex-direction: row;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    margin-right: 10px;
  }
}
.upload-div {
  display: flex;
  flex-direction: row;
  .upload-img {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    border: 1px solid rgb(238, 238, 238);
  }
  .upload-content {
    margin-left: 6px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .content-text {
      width: 80px;
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      border: 1px solid rgb(77, 148, 255);
      color: rgb(77, 148, 255);
      font-size: 12px;
    }
    .content-texts {
      color: rgb(162, 170, 188);
      font-size: 12px;
      white-space: nowrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/student/matureStudent.vue